import React from "react";
import {
  IonButton,
  IonButtons, IonContent,
  IonHeader, IonIcon, IonPage, IonProgressBar,
  IonTitle, IonToolbar, withIonLifeCycle,
} from "@ionic/react";
import {arrowBack, calendar, document, fileTrayStacked, medkit} from "ionicons/icons";
import AbaVeterinario from "./AbaVeterinario";
import AbaFazendas from "./AbaFazendas";
import AbaEventos from "./AbaEventos";
import {VeterinarioObject} from "../../models/Veterinario";
import {goBackNG} from "../../lib/utils";
import fb from "../../lib/firebase";
import {NavFooter} from "../../components/NavFooter";
import {AppState} from "../../models/app";
import {AppDispatch, RootState} from "../../global.state";
import {connect} from "react-redux";
import {debug} from "../../config";


interface Props {
  match: {params: {instanceId: string}};
  history: any;
  app: AppState;
  dispatch: AppDispatch;
}

interface State {
  instance: VeterinarioObject | undefined;
  selectedTab: string;
  loading: boolean;
}

class Veterinario extends React.Component<Props, State> {
  private cancelListener: () => void;

  constructor(props: Props) {
    super(props);
    this.state = {
      instance: undefined,
      selectedTab: "home",
      loading: true,
    };
    this.cancelListener = () => {};
  }

  ionViewWillEnter() {
    // reset state
    const instanceId = this.props.match.params.instanceId;
    const instance = this.state.instance;
    if (!instance || instance.id !== instanceId) {
      this.setState({instance: undefined, loading: true, selectedTab: "home"});
    }

    this.installListener();
  }
  ionViewDidLeave() {
    this.cancelListener();
  }

  installListener = () => {
    const instanceId = this.props.match.params.instanceId;
    const doc = fb.db.collection('veterinarios').doc(instanceId);
    this.cancelListener = doc.onSnapshot((snap) => {
      const instance = fb.doc(snap) as VeterinarioObject;
      debug(`Veterinário ${instanceId}`, instance);
      this.setState({
        instance,
        loading: false,
      });
    });
  };

  onChangeTab = (selectedTab:string) => {
    this.setState({selectedTab});
  };

  onClickBack = () => {
    goBackNG(this.props.app.jumpHistory, this.props.dispatch, this.props);
  };

  render() {
    const tabs:any[] = [
      {
        tab: "home",
        icon: document,
        label: "Cadastro",
      },
      {
        tab: "fazendas",
        icon: fileTrayStacked,
        label: "Fazendas",
      },
      {
        tab: "historico",
        icon: calendar,
        label: "Histórico",
      }
    ];

    return (
      <IonPage>
        <IonHeader>
          <IonToolbar color="primary">
            <IonButtons slot="start">
              <IonButton onClick={this.onClickBack}>
                <IonIcon slot="start" icon={arrowBack}/>
              </IonButton>
            </IonButtons>
            <IonTitle className="font-condensed">
              {this.state.instance && this.state.instance.nome}
            </IonTitle>
            <IonIcon icon={medkit} slot="primary" class="pr-3 text-2xl"/>
          </IonToolbar>
        </IonHeader>

        <IonContent>
          {
            !this.state.instance ? <IonProgressBar type="indeterminate"/> :
              <>
                {
                  this.state.selectedTab === "home" &&
                  <AbaVeterinario
                    instance={this.state.instance}
                    goBack={this.onClickBack}
                    loading={this.state.loading}
                  />
                }
                {
                  this.state.selectedTab === "fazendas" &&
                  <AbaFazendas
                    instance={this.state.instance}
                    instanceType="veterinarios"
                    history={this.props.history}
                  />
                }
                {
                  this.state.selectedTab === "historico" &&
                  <AbaEventos
                    instance={this.state.instance}
                    history={this.props.history}
                  />
                }
              </>
          }
        </IonContent>
        <NavFooter
          value={this.state.selectedTab}
          onChange={this.onChangeTab}
          tabs={tabs}
        />
      </IonPage>
    );
  }
}

export default connect(({app}: RootState) => ({app}))(withIonLifeCycle(Veterinario));
